import React, { useState } from 'react';
import {
    MdArrowUpward, } from 'react-icons/md';
const ScrollButton = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <div className="scroll-button" style={{
            position: 'fixed',
            width: '100%',
            left: '50%',
            bottom: '18%',
            height: '20px',
            fontSize: '3rem',
            zIndex: 1,
            cursor: 'pointer',
        }}>
            <MdArrowUpward onClick={scrollToTop}
                style={{ background:'rgb(23, 181, 230)',color:'#fff',borderRadius:'50%', display: visible ? 'inline' : 'none' }} />
        </div>
    );
}

export default ScrollButton;